const map = {
	"./2010/Registration/Index.vue": 729,
	"./2011/Registration/Index.vue": 62563,
	"./2012/Registration/Index.vue": 38605,
	"./2013/Registration/Index.vue": 51610,
	"./2014/Registration/Index.vue": 23165,
	"./2015/Registration/Index.vue": 56632,
	"./2016/Registration/Index.vue": 55623,
	"./2018/Registration/Index.vue": 19874,
	"./2019/Registration/Index.vue": 76506,
	"./2021/Registration/Index.vue": 75957,
	"./2022/Registration/Index.vue": 70313,
	"./2023/Registration/Index.vue": 25385,
	"./2024/Registration/Index.vue": 76283,
	"./2025/Registration/Index.vue": 76104,
	"./2026/Registration/Index.vue": 52506
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85904;